
'use strict'

import { isMobileRes, isMobileDevice } from "../utils/Utils";
import ModalNewBrand from "./ModalNewBrand";

class BrandSelectorClass{
    constructor(){
        this.main = document.getElementById('brand_selector');

        if(this.main == null){
            return;
        }

        this._brandItems = [];

        this._list = this.main.querySelector('.brand-selector__list');

        this._actionBtn = this.main.querySelector('.action_btn');
        
        this._searchInput = this.main.querySelector('.search_input');
        this._valueLabel = this.main.querySelector('.value_label');

        this._closeBtn = this.main.querySelector('.close_btn');

        this._modalNewBrand = new ModalNewBrand();
        this._newBrandBtn = this.main.querySelector('.new_brand_btn');
        
        this._currentBrandId = null;
        this._currentBrandName = null;
        
        this._isOpen = false;
        this._readOnly = false;
        this._newBrandEnabled = false;
        
        Array.from(this.main.querySelectorAll('.brand_item')).forEach((brandItem)=>{
            this._brandItems.push(brandItem);
            brandItem.addEventListener('click', this._onClickBrandItem.bind(this));
        });

        this._noResults = this.main.querySelector('.no_results_item');

        this._closeBtn.addEventListener('click', this.hide.bind(this))
        this._newBrandBtn.addEventListener('click', this.newBrand.bind(this))
        this._searchInput.addEventListener('input', this._onSearchInputChange.bind(this));
        this._actionBtn.addEventListener('click', this._onClickActionBtn.bind(this));

        document.addEventListener('click', this._onClickDocument.bind(this));
        this.main.addEventListener('click', (e)=>{
            e.stopPropagation();
        });
    }

    show(){
        this._isOpen = true;
        
        this._searchInput.value = '';
        this._onSearchInputChange();
        this._searchInput.focus();
        
        if(isMobileDevice() || isMobileRes()){
            document.body.classList.add('block-scroll');
        }
        
        this.main.classList.add('brand-selector--open');

        setTimeout(() => {
            this.main.classList.add('brand-selector--open-anim');
        }, 0);

        this.hideTooltip();
        this.main.dispatchEvent(new CustomEvent('brandIsOpen'));
    }

    hide(){
        if (this._isOpen) {
            this.main.classList.remove('brand-selector--open', 'brand-selector--open-anim');
            document.body.classList.remove('block-scroll');
        }
        this._isOpen = false;
    }

    newBrand(e) {
        e.preventDefault();
        this._modalNewBrand.show();
        this.hide();
    }

    clear(){
        this.value = null;
        this._currentBrandId = null;
        this._currentBrandName = null;
        this._searchInput.value = '';
        this._onSearchInputChange();
    }
    
    set value(brandId){
        this._currentBrandId = brandId;

        let brandItem = this.main.querySelector(`.brand_item[data-id="${this._currentBrandId}"]`);

        if(brandItem != null){
            this._currentBrandName = brandItem.getAttribute('data-name');
            
            this._valueLabel.innerHTML = brandItem.textContent;
            this.main.classList.add('brand-selector--filled');
        }else{
            this._currentBrandName = null;

            this._valueLabel.innerHTML = 'Brand';
            this.main.classList.remove('brand-selector--filled');
        }
        
    }

    get value(){
        return this._currentBrandId;
    }

    get name(){
        return this._currentBrandName;
    }

    get isOpen() {
        return this._isOpen;
    }

    set newBrandEnabled(value) {
        this._newBrandEnabled = value;
        if (value) {
            this.main.querySelector('.new_brand_btn').classList.remove('d-none');
        } else {
            this.main.querySelector('.new_brand_btn').classList.add('d-none');
        }
    }

    setValueDispatchingEvent(brandId) {
        this.value = brandId;
        this.main.dispatchEvent(new CustomEvent('brandChange'));
    }

    getBrandsCount() {
        return this._brandItems.length;
    }

    getBrandByIndex(index){
        let item = this._brandItems[index];
        
        return {id: item.dataset.id, name: item.dataset.name};
    }

    set actionButtonSize(size = 'big'){
        this._actionBtn.classList.remove('form-input-box-actionable--size-2');
        this._actionBtn.classList.remove('form-input-box-actionable--size-3');

        switch(size) {
            case 'small':
                this._actionBtn.classList.add('form-input-box-actionable--size-3');
            break;   
            case 'medium':
                this._actionBtn.classList.add('form-input-box-actionable--size-2');
            break;  
            case 'big':
            default:
            break;        
        }
    }

    set readOnly(readOnly){
        this._readOnly = readOnly;
        
        if(this._readOnly){
            this.main.classList.add('brand-selector--disabled');
        }else{
            this.main.classList.remove('brand-selector--disabled');
        }
    }

    showTooltip(){
        this.main.classList.add('brand-selector--show-tooltip');
    }

    hideTooltip(){
        this.main.classList.remove('brand-selector--show-tooltip');
    }

    addEventListener(event, callback){
        this.main.addEventListener(event, callback);
    }

    _onClickActionBtn(e){
        if(!this._readOnly){
            if(this._isOpen){
                this.hide();
            }else{
                this.show();
            }
        }
    }

    _onSearchInputChange(e = null){
        let search = this._searchInput.value.trim();
        let hasResult = false;
        
        Array.from(this.main.querySelectorAll('.brand_item')).forEach((brandItem)=>{
            if(search == '' || brandItem.textContent.toUpperCase().indexOf(search.toUpperCase()) != -1){
                brandItem.style.display = 'block';
                hasResult = true;
            }else{
                brandItem.style.display = 'none';
            }
        });
        
        if(hasResult){
            this._noResults.classList.add('d-none');
        }else{
            this._noResults.classList.remove('d-none');
        }
    }

    _onClickBrandItem(e){
        this.value = e.currentTarget.getAttribute('data-id');

        this.hide();

        this.main.dispatchEvent(new CustomEvent('brandChange'));
    }

    _onClickDocument(e) {
        this.hide();
    }
}

const BrandSelector = new BrandSelectorClass();
Object.seal(BrandSelector);

export default BrandSelector;